import { HttpRequest3fsc4149kgwfg as HttpRequest } from './HttpRequest.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultHttpRequestClass;
function DefaultHttpRequest() {
  if (DefaultHttpRequestClass === VOID) {
    class $ {
      constructor(call, data) {
        this.b63_1 = call;
        this.c63_1 = data.c5r_1;
        this.d63_1 = data.b5r_1;
        this.e63_1 = data.e5r_1;
        this.f63_1 = data.d5r_1;
        this.g63_1 = data.g5r_1;
      }
      o5o() {
        return this.b63_1;
      }
      gw() {
        return this.o5o().gw();
      }
      p5o() {
        return this.c63_1;
      }
      q5o() {
        return this.d63_1;
      }
      a2p() {
        return this.e63_1;
      }
      b56() {
        return this.f63_1;
      }
      i5o() {
        return this.g63_1;
      }
    }
    initMetadataForClass($, 'DefaultHttpRequest', VOID, VOID, [HttpRequest()]);
    DefaultHttpRequestClass = $;
  }
  return DefaultHttpRequestClass;
}
//region block: exports
export {
  DefaultHttpRequest as DefaultHttpRequest19v463zllbymg,
};
//endregion

//# sourceMappingURL=DefaultHttpRequest.mjs.map
